import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { provideUtmService } from './providers';

@NgModule({
  imports: [CommonModule]
})
export class UtmModule {
  static forRoot(utmConfigProviders: Provider[]): ModuleWithProviders<UtmModule> {
    return {
      ngModule: UtmModule,
      providers: [...utmConfigProviders, provideUtmService()]
    };
  }
}
